// extracted by mini-css-extract-plugin
export default {"buttonStyle":"GoogleSignIn_buttonStyle__8N9a5","textStyle":"GoogleSignIn_textStyle__E1x7K"};